module.exports = __webpack_public_path__ + "static/media/hippo-1.534ece71.jpg";